// import { useEffect, useMemo, useState } from "react";
// import { Row } from "antd";
// import { FaRegFileAlt } from "react-icons/fa";

// import CustomButton from "@/components/customButton";
// import CustomFormInput from "@/components/customInput";
// import SearchBox from "@/components/searchInput";
// import Table from "@/components/Table";
// import StepperForm from "./AddOffer";

// import { getColumns } from "./config";
// import { useTypedSelector } from "@/hooks";
// import { useFetchLivePayBenchmarkingReportQuery } from "@/services";

// import "./index.less";

// const DynamicReport = () => {
//   // const companyId = useTypedSelector(state => state.auth?.user?.company?.id);
//   const companyId = 6;

//   const { data: reportData, isLoading, isFetching, isError } =
//     useFetchLivePayBenchmarkingReportQuery({ company_id: companyId });

//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [reportName, setReportName] = useState("");
//   const [stepperForm, setStepperForm] = useState(false);

//   const columns = useMemo(() => getColumns({ handleRowClick: () => { } }), []);

//   const handleCreate = () => {
//     setIsModalOpen(false);
//     setStepperForm(true);
//   };

//   const handleCancel = () => {
//     setIsModalOpen(false);
//     setReportName("");
//   };

//   useEffect(() => {
//     console.log("DynamicReport mounted");
//   }, []);

//   return (
//     <>
//       <div className="bg-themeCore">
//         <div className="jobCreationBar bg-white px-4 py-6 rounded-lg flex justify-between items-center">
//           <div className="title text-themeBlue font-medium text-3xl">
//             Live Pay &gt; Dynamic Reports
//           </div>
//           <CustomButton
//             onClick={() => setIsModalOpen(true)}
//             btnName="Generate Dynamic Reports"
//             customClasses="shadow-md font-medium border py-1 px-6 !border-themeBorder ml-4"
//             iconPosition="right"
//           >
//             <FaRegFileAlt size={15} className="text-white font-bold" />
//           </CustomButton>
//         </div>
//       </div>

//       <div className="Listing mt-6 bg-white px-14 py-4 rounded-lg">
//         <SearchBox
//           placeholder="Type to search..."
//           value=""
//           onChange={() => { }}
//         />
//         <Row>
//           <Table
//             isLoading={isLoading || isFetching}
//             data={reportData?.data}
//             columns={columns}
//           />
//         </Row>
//       </div>

//       {isModalOpen && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
//           <div className="bg-white rounded-lg w-full max-w-lg shadow-2xl border-4 border-blue-50">
//             <div className="px-6 pt-6 pb-4">
//               <h2 className="text-lg font-semibold text-themeBlue text-center">
//                 Please set the dynamic report name
//               </h2>
//             </div>

//             <div className="px-24 pb-6">
//               <CustomFormInput
//                 type="text"
//                 value={reportName}
//                 onChange={e => setReportName(e.target.value)}
//                 customClass="w-full rounded-xl px-3 py-2 border mb-16 focus:outline-none bg-gray-100 placeholder-themeBlue custom-placeholder"
//                 placeholder="Enter report name here..."
//               />

//               <div className="flex justify-center gap-3">
//                 <CustomButton
//                   onClick={handleCreate}
//                   disabled={reportName.trim().length < 3}
//                   btnName="Create"
//                   customClasses={`${reportName.trim().length < 3 && ' cursor-not-allowed'}`}
//                 />
//                 <CustomButton
//                   onClick={handleCancel}
//                   btnName="Cancel"
//                 // customClasses="border border-themeBlue text-themeBlue px-6 py-2"
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {stepperForm && (
//         <StepperForm
//           reportName={reportName}
//           handleClose={() => {
//             setStepperForm(false);
//             setReportName("");
//           }}
//         />
//       )}
//     </>
//   );
// };

// export default DynamicReport;

import { useEffect, useMemo, useState } from "react";
import { Row } from "antd";
import { FaRegFileAlt } from "react-icons/fa";

import CustomButton from "@/components/customButton";
import CustomFormInput from "@/components/customInput";
import SearchBox from "@/components/searchInput";
import Table from "@/components/Table";
import StepperForm from "./AddOffer";

import { getColumns } from "./config";
import { useTypedSelector } from "@/hooks";
import {
  useFetchLivePayBenchmarkingReportQuery,
  useLazyDownloadPayBenchmarkingReportQuery
} from "@/services";

import "./index.less";

const DynamicReport = () => {
  const companyId = useTypedSelector(state => state.auth?.user?.company?.id);
  // const companyId = 6;

  // const { data: reportData, isLoading, isFetching, isError } =
  //   useFetchLivePayBenchmarkingReportQuery({ company_id: companyId });

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const { data: reportData, isLoading, isFetching } =
    useFetchLivePayBenchmarkingReportQuery({
      company_id: companyId,
      page,
      page_size: pageSize,
    });



  const [isModalOpen, setIsModalOpen] = useState(false);
  const [reportName, setReportName] = useState("");
  const [stepperForm, setStepperForm] = useState(false);

  const [
    triggerDownload,
    { isLoading: isDownloadLoading }
  ] = useLazyDownloadPayBenchmarkingReportQuery();

  // const handleRowClick = async (report) => {
  //   console.log(report)
  //   try {
  //     const response = await triggerDownload({
  //       company_id: companyId,
  //       report_id: report?.id
  //     });

  //     const blob = new Blob([response], { type: "application/octet-stream" });
  //     const url = window.URL.createObjectURL(blob);
  //     const a = document.createElement("a");
  //     a.href = url;
  //     a.download = `${report?.name}.xlsx`;
  //     a.click();
  //     window.URL.revokeObjectURL(url);
  //   } catch (error) {
  //     console.error("Download failed:", error);
  //   }
  // };

  const handleRowClick = async (report) => {
    try {
      await triggerDownload({
        company_id: companyId,
        report_id: report?.id
      });
      // ✅ tomService already downloads it
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  const columns = useMemo(() => getColumns({ handleRowClick }), []);

  const handleCreate = () => {
    if (reportName.trim().length < 3) {
      return
    }
    setIsModalOpen(false);
    setStepperForm(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setReportName("");
  };

  useEffect(() => {
    console.log("DynamicReport mounted");
  }, []);

  return (
    <>
      <div className="bg-themeCore">
        <div className="jobCreationBar bg-white px-4 py-6 rounded-lg flex justify-between items-center">
          <div className="title text-themeBlue font-medium text-3xl">
            Live Pay Tool &gt; Dynamic Reports
          </div>
          <CustomButton
            onClick={() => setIsModalOpen(true)}
            btnName="Generate Dynamic Reports"
            customClasses="shadow-md font-medium border py-1 px-6 !border-themeBorder ml-4"
            iconPosition="right"
          >
            <FaRegFileAlt size={15} className="text-white font-bold" />
          </CustomButton>
        </div>
      </div>

      <div className="Listing mt-6 bg-white px-5 py-4 rounded-lg">
        <SearchBox
          placeholder="Type to search..."
          value=""
          onChange={() => { }}
        />
        <Row>
          {/* <Table
            isLoading={isLoading || isFetching}
            data={reportData?.data}
            columns={columns}
          /> */}
          <Table
            isLoading={isLoading || isFetching}
            data={reportData?.data}
            columns={columns}
            pagination
            page={page}
            pageSize={pageSize} // ✅ pass size
            count={reportData?.pagination?.count}
            onChangePage={(p, size) => {
              setPage(p);
              setPageSize(size || 10); // ✅ backward safe
            }}
          />


        </Row>
      </div>

      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded-lg w-full max-w-lg shadow-2xl border-4 border-blue-50">
            <div className="px-6 pt-6 pb-4">
              <h2 className="text-lg font-semibold text-themeBlue text-center">
                Please set the dynamic report name
              </h2>
            </div>

            <div className="px-24 pb-6">
              <CustomFormInput
                type="text"
                value={reportName}
                onChange={e => setReportName(e.target.value)}
                customClass="w-full rounded-xl px-3 py-2 border focus:outline-none bg-gray-100 placeholder-themeBlue custom-placeholder"
                placeholder="Enter report name here..."
              />
              <p className="text-xs text-gray-400  mb-14 ml-2">title should be atleast 3 characters</p>

              <div className="flex justify-center gap-3">
                <CustomButton
                  onClick={handleCreate}
                  disabled={reportName.trim().length < 3}
                  btnName="Create"
                  customClasses={`${reportName.trim().length < 3 && ' cursor-not-allowed'}`}
                  styles={{ width: "10rem" }}

                />
                <CustomButton
                  onClick={handleCancel}
                  btnName="Cancel"
                  styles={{ background: "lightgray", color: "black", width: "10rem" }}
                />
              </div>
            </div>
          </div>
        </div>
      )}

      {stepperForm && (
        <StepperForm
          companyId={companyId}
          reportName={reportName}
          handleClose={() => {
            setStepperForm(false);
            setReportName("");
          }}
        />
      )}
    </>
  );
};

export default DynamicReport;